import type { FunctionComponent } from 'react';
import { useIsConsumerFlowEnabled } from '@/hooks/use-app-mode';
import { ConsumerNotAvailable } from '../pages/consumer-not-available';

export function withConsumerGate<TProps extends object>(
  Page: FunctionComponent<TProps>,
): FunctionComponent<TProps> {
  function ConsumerGated(props: TProps) {
    if (!useIsConsumerFlowEnabled()) return <ConsumerNotAvailable />;
    return <Page {...props} />;
  }

  ConsumerGated.displayName = `withConsumerGate(${Page.displayName ?? Page.name})`;

  return ConsumerGated;
}
